export { Loader, LoaderContainer } from './Loader';


// WEBPACK FOOTER //
// ./src/components/Loader/index.js